import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalSizeEnum } from '../../../enum/modal-size.enum';
import { ModifyColumnsModalComponent } from '../modify-columns-modal/modify-columns-modal.component';
import { DynamicTableColumnModel } from '../../../models/dto/core/dynamicTableColumn.model';
import { ArrayUtils } from '../../../utils/array.utils';
import { StringUtils } from '../../../utils/string.utils';
import { GeneralUtils } from '../../../utils/general.utils';


@Component({
  selector: 'app-modify-column-widget',
  templateUrl: './modify-column-widget.component.html',
  styleUrls: ['./modify-column-widget.component.css']
})
export class ModifyColumnWidgetComponent implements OnInit {

  @Input() screenCode: string;
  @Input() reportType: string;
  @Input() cols: DynamicTableColumnModel[];
  @Output() valueChange: EventEmitter<any> = new EventEmitter();

  @Output() columnsUpdated: EventEmitter<DynamicTableColumnModel[]> = new EventEmitter();
  constructor(
    private modalService: NgbModal,) { }

  ngOnInit(): void {
  }

  openModifyColumnModal() {
    const modalRef = this.modalService.open(ModifyColumnsModalComponent, {
      backdrop: "static", centered: true, scrollable: true, size: ModalSizeEnum.LARGE
    });

    //modal  veri geçişi 
    modalRef.componentInstance.screenCode = this.screenCode;
    modalRef.componentInstance.reportType = this.reportType;
    modalRef.componentInstance.availableColumns =
      GeneralUtils.copy(this.cols.filter((x) =>
        StringUtils.isEmpty(this.reportType) ||
        ArrayUtils.isEmpty(x.reportType) ||
        x.reportType.indexOf(this.reportType) > -1));

    //modal cevap döndüğünde
    modalRef.componentInstance.valueChange.subscribe((receivedEntry) => {

      this.valueChange.emit(receivedEntry);

      // modal kapat
      modalRef.close();
    });

  }
}
